// Info:
// https://earthctzn.medium.com/a-react-redux-state-demo-f6846d44b069
// https://codesandbox.io/s/todo-app-with-redux-forked-qks60q?file=/src/components/VisibilityFilters.js

import React from "react";
import ReactDOM from "react-dom/client";
import "./style/_index.css";
import App from "./App";
import reportWebVitals from "./report-web-vitals";
import { Provider } from "react-redux";
import store from "./redux/store";

// (STORE) ... DISPATCH -> ACTION -> REDUCER
// https://www.youtube.com/watch?v=CVpUuw9XSjY
// store.subscribe(() => console.log(store.getState()));
// store.displatch(increment());

const root = ReactDOM.createRoot(document.querySelector("#root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
